import { objectSelector } from 'theme/utils';
import { request } from '../axios/request';

import {
  FETCH_TRANSFER_ORDER_LIST_PENDING,
  FETCH_TRANSFER_ORDER_LIST_REJECTED,
  FETCH_TRANSFER_ORDER_LIST_FULFILLED,
  START_TRANSFER_ORDER_LIST_AUTO_RELOAD,
  STOP_TRANSFER_ORDER_LIST_AUTO_RELOAD,
  SET_ACTIVE_STATUS_FOR_TRANSFER_ORDER_LIST,
  CLEAR_TRANSFER_ORDER_LIST,
} from '../constants/transferOrderList';

import { fetchTransferStockLocations } from './transferStockLocations';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_TRANSFER_ORDER_LIST_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_TRANSFER_ORDER_LIST_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_TRANSFER_ORDER_LIST_REJECTED,
  error,
});

const startAutoReloadInterval = (data) => ({
  type: START_TRANSFER_ORDER_LIST_AUTO_RELOAD,
  data,
});

const stopAutoReloadInterval = () => ({
  type: STOP_TRANSFER_ORDER_LIST_AUTO_RELOAD,
});

export const setActiveStatus = (data) => ({
  type: SET_ACTIVE_STATUS_FOR_TRANSFER_ORDER_LIST,
  data,
});

export const clearTransferOrderList = () => ({
  type: CLEAR_TRANSFER_ORDER_LIST,
});

export const fetchTransferOrders =
  (params = {}) =>
  (dispatch, getState) => {
    const {
      transferOrderList: { activeStatusId },
    } = getState();
    const _params = {
      state: activeStatusId,
      ...params,
      limit: 50,
      page: 1,
    };

    const responseLanguage = objectSelector($A, 'RESPONSE_LANGUAGE', 'en-us');

    dispatch(pending());
    dispatch(setActiveStatus(_params.state));

    request({
      method: 'get',
      url: OMS.OMS.TRANSFER_ORDER_LIST,
      params: _params,
      headers: {
        'accept-language': responseLanguage,
      },
    })
      .then((response) => {
        const { data } = response;
        dispatch(fulfilled(data));
      })
      .catch((error) => {
        dispatch(rejected(error));
      });
  };

export const startAutoReload = (milliseconds) => (dispatch) => {
  const autoReloadIntervalId = setInterval(() => {
    dispatch(fetchTransferOrders());
    dispatch(fetchTransferStockLocations());
  }, milliseconds);

  dispatch(startAutoReloadInterval(autoReloadIntervalId));
};

export const stopAutoReload = () => (dispatch, getState) => {
  const {
    transferOrderList: { autoReloadIntervalId },
  } = getState();
  if (!autoReloadIntervalId) return;

  clearInterval(autoReloadIntervalId);
  dispatch(stopAutoReloadInterval());
};



// WEBPACK FOOTER //
// ./src/actions/transferOrderList.js